TS.ns('WL');

WL.leasingOfferAssetModel = new Class({
    Extends: WL.documentBase,

    initialize: function (config) {
        var me = this;

        me.parent(config);

        var monitoredFields = ['Price', 'Discount', 'LuxuryTax', 'Qtty', 'BankId', 'Amount', 'ExchangeRateDate', 'CurrencyId'];
        createHandler = function (fieldName) {
            var f = fieldName;
            return function (newValue) {
                me.onInfoChanged(f);  
            }; 
        };

        var monitoredFieldsProp = ['AgreedAnnualMileage', 'MileageAtStart', 'DocumentDetailPropertyCollection'];
        createHandlerProp = function (fieldName) {
            var f = fieldName;
            return function (newValue) {
                me.onPropChanged(f, -1);
            };
        };

        $.each(monitoredFields, function (idx, fieldName) {
            if (me.Document[fieldName] != undefined) {
                me.watchProperty(me.Document[fieldName], createHandler(fieldName), me);
            }
        });

        $.each(monitoredFieldsProp, function (idx, fieldName) {
            if (me.Document[fieldName] != undefined) {
                me.watchProperty(me.Document[fieldName], createHandlerProp(fieldName), me);
            }
        });   

    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var currencyList = me.getDomainProperty('lkpCurrency_Property');
        var taxRateList = me.getDomainProperty('lkpTaxRate_Property');

        me.watchProperty(me.Document.ItemId, me.onItemIdChanged, me);
        me.watchProperty(me.Document.BaumasterCode, me.onItemBaumasterCodeChanged, me);

        var propertyList = me.getDomainProperty('PropertyList');
        if (propertyList) {
            propertyList.on('addNew', me.onPropertyAdded);
            propertyList.on('cellValueChanged', me.onPropertyChanged, me);
            propertyList.on('cellBeginEdit', me.onPropertyEdit, me);
        }

        if (taxRateList != null) {
            taxRateList.on('selectionChanged', me.onTaxRateChanged, me);
        }

        if (currencyList != null) {
            currencyList.on('selectionChanged', me.onCurrencyChanged, me);
        }
    },

    onItemIdChanged: function (newValue) {
        var me = this;

        if (me.isItemChanging === true)
            return;

        me.isItemChanging = true;

        me.performServerCommand({
            cmd: 'LoadItemById',
            submitModel: true,
            extraData: { ItemId: newValue },
            blockUI: false,
            callback: function () {
                me.isItemChanging = false;
            } 
        });
    },

    onItemBaumasterCodeChanged: function (newValue) {
        var me = this;

        if (me.isItemChanging === true)
            return;
        me.isItemChanging = true;

        me.performServerCommand({
            cmd: 'LoadItemByBaumasterCode',
            submitModel: true,
            extraData: { BaumasterCode: newValue },
            blockUI: false ,
            callback: function () {
                me.isItemChanging = false;
            }
        });
    },

    onPropertyAdded: function (e) {
        var me = this,
          rec = e.item;

        rec.PropertyTypeCode = new ko.observable('Text');
        rec.EditorName = new ko.observable('Text');
        rec.EditorType = new ko.observable('Text');
    },

    onPropertyChanged: function (e) {
        var me = this,
          rec = e.item;

        me.onPropChanged('DynamicField', e.rowIdx)

        if (e.fieldName != 'PropertyId')
            return;

        me.performServerCommand({
            cmd: 'RefreshProperty',
            submitModel: true,
            extraData: {
                NewValue: e.newValue,
                rowIdx: e.rowIdx
            },
            blockUI: true
        })
    },

    onTaxRateChanged: function (newValue) {
        var me = this;

        me.onInfoChanged("TaxRate");
    },

    onCurrencyChanged: function (newValue) {
        var me = this;

        me.onInfoChanged("Currency");
    },

    onInfoChanged: function (fieldName) {
        var me = this;

        if (me.InsideInfoChanged === true)
            return;

        me.InsideInfoChanged = true;
          
        me.performServerCommand(
            {
                cmd: 'ComputeFinancialInformation',
                submitModel: true,
                extraData: { fieldName: fieldName },
                callback: function () {
                    me.InsideInfoChanged = false;
                }
            });
    },

    onPropertyEdit: function (e) {  
        var me = this,
            rec = e.item;
        if (e.record.PropertyId() == null)
            return;

        if (e.record.IsReadOnly() == true)
            e.preventDefault();
    },

    onPropChanged: function (fieldName, rowIdx) {
        var me = this;

        if (me.InsideInfoChanged === true)
            return;

        me.InsideInfoChanged = true;

        me.performServerCommand(
            {
                cmd: 'PropFinancialInformation',
                submitModel: true,
                extraData: { fieldName: fieldName, rowIdx: rowIdx },
                callback: function () {
                    me.InsideInfoChanged = false;
                }
            });
    }

});

